import { useQuery } from '@tanstack/react-query'
import { USERS } from '../constants/endpoints'
import { getUsers } from '../utils/getUsers'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useUsersQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [USERS, userId],
    queryFn: getUsers,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
